"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileToLatLng = tileToLatLng;
exports.latLngToTile = latLngToTile;
exports.getTriangleAreaSign = getTriangleAreaSign;
exports.isScreenXYInPolygon = isScreenXYInPolygon;
exports.convertScreenXYToLatLng = convertScreenXYToLatLng;
exports.convertLatLngToScreenXY = convertLatLngToScreenXY;
exports.getTileTopLeftScreenPixelCoordinates = getTileTopLeftScreenPixelCoordinates;
exports.convertPolygonToLatLng = convertPolygonToLatLng;
exports.convertPolygonToScreenXY = convertPolygonToScreenXY;
exports.convertParcelToLatLng = convertParcelToLatLng;
exports.translateScreenXYFromMapTile = translateScreenXYFromMapTile;
exports.isScreenXYInsideMinimumBoundingRect = isScreenXYInsideMinimumBoundingRect;
exports.getTileRowColFromScreenCoords = getTileRowColFromScreenCoords;
exports.getPathLineFromCoordinateArray = getPathLineFromCoordinateArray;
exports.getForwardableProperties = getForwardableProperties;
exports.getCustomRegionPolygonKey = getCustomRegionPolygonKey;
exports.translatePolygonToMapTile = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Given a zoom, and a map tile's row and column, determines the latitude and longitude in degrees
 * of the top left corner of the tile.
 * @param row
 * @param column
 * @param zoom
 * @returns {{latDeg: number, lngDeg: number}}
 */
function tileToLatLng(row, column, zoom) {
  // eslint-disable-next-line no-restricted-properties
  var zoomScale = Math.pow(2, zoom); // Scale down from the zoom level

  var rowScaledDown = row / zoomScale;
  var colScaledDown = column / zoomScale; // Convert down scaled to mercator projection

  var rowMercator = (rowScaledDown * -2 + 1) * Math.PI;
  var colMercator = (colScaledDown * 2 - 1) * Math.PI; // Convert mercator projection to lat/lng in radians

  var latRad = Math.atan(Math.sinh(rowMercator));
  var lngRad = colMercator; // Convert radians to degress

  var latDeg = latRad * 180 / Math.PI;
  var lngDeg = lngRad * 180 / Math.PI;
  return {
    latDeg: latDeg,
    lngDeg: lngDeg
  };
}
/**
 * Given a latitude and longitude in degrees, as well as a zoom, determines the row and column
 * of the map tile at that location.
 * @param lat
 * @param lng
 * @param zoom
 * @returns {{row: number, column: number}}
 */


function latLngToTile(lat, lng, zoom) {
  // eslint-disable-next-line no-restricted-properties
  var zoomScale = Math.pow(2, zoom); // Convert from degrees to radians

  var latRad = lat * Math.PI / 180;
  var lngRad = lng * Math.PI / 180; // Convert from radians to Mercator projection

  var rowMerc = Math.asinh(Math.tan(latRad));
  var columnMerc = lngRad; // Scale mercator projection to 0 - 1 and shift origin to top left of grid

  var rowScaledOriginShifted = (1 - rowMerc / Math.PI) / 2;
  var colScaledOriginShifted = (1 + columnMerc / Math.PI) / 2; // Scale to current zoom level

  var row = Math.floor(rowScaledOriginShifted * zoomScale);
  var column = Math.floor(colScaledOriginShifted * zoomScale);
  return {
    row: row,
    column: column
  };
}
/**
 * Checks to see if the triangle formed from three vertices V_i, V_{i+1}, P is clockwise
 * or counter clockwise. The algorithm specifically computes the signed area, then if the
 * area is positive, the triangle is clockwise, if it's negative it's counterclockwise. If
 * it's zero it is a line. This is used for the winding number algorithm.
 *
 * For further reading see the "Modern Triangles" section of http://geomalgorithms.com/a01-_area.html
 *
 * @param linePoint0 first object{x,y} coordinate of line
 * @param linePoint1 second object{x,y} coordinate of line
 * @param testPoint object{x,y} coordinate to check if it's left or right of the line
 * @returns {number}
 */


function getTriangleAreaSign(linePoint0, linePoint1, testPoint) {
  return (linePoint1.x - linePoint0.x) * (testPoint.y - linePoint0.y) - (testPoint.x - linePoint0.x) * (linePoint1.y - linePoint0.y);
}
/**
 * Takes a pair of screen coordinates and a polygon array and determines if the mouse is inside
 * of the polygon. This function assumes that the mouseX, mouseY, and polygons are all addressed
 * to the same space. Meaning that the polygon values has already been transformed in any way
 * necessary to ensure that the values coordinate to where the polygon is on the screen.
 *
 * For example, parcel polygon arrays only draw the basic shape, they are not inherently positioned
 * on the screen correctly. The MapContentPositioner performs transformations on them based
 * on the tile they are in. In order to use this function for parcels, you will need to use helper
 * functions to translate the polygon, like translatePolygonToMapTile() below.
 *
 * This function uses the "Winding Number" inclusion of a point in a polygon algorithm.
 * The algorithm is modified to handle the fact that the map is not on a regular cartesian plane,
 * but is instead on a plane where the Y value increases as you move down on the map.
 * We use this algorithm rather than the crossing number algorithm because the crossing number
 * algorithm fails for complex polygons
 *
 * If you're interested in the math, see http://geomalgorithms.com/a03-_inclusion.html
 *
 * @param screenX A screen X coordinate on the screen
 * @param screenY A screen Y coordinate on the screen
 * @param polygon An array of x, y coordinates like [0, 0, 1, 1, 2, 2, 0, 0]
 * @returns {boolean}
 */


function isScreenXYInPolygon(screenX, screenY, polygon) {
  // If there are less than 3 pairs of coordinates we cannot form a polygon
  if (polygon.length < 6) {
    return false;
  }

  var point = {
    x: screenX,
    y: screenY
  };
  var windingNumberCount = 0;

  for (var i = 0; i < polygon.length - 3; i += 2) {
    var currentX = polygon[i];
    var currentY = polygon[i + 1];
    var nextX = polygon[i + 2];
    var nextY = polygon[i + 3]; // Get the area of the triangle formed by the line between the current polygon points
    // and the mouse point. Really all we care about here is the sign of the area

    var triangleAreaWithDirection = getTriangleAreaSign({
      x: currentX,
      y: currentY
    }, {
      x: nextX,
      y: nextY
    }, point); // If the current mouse coordinate pair is between the current and next point on the y axis
    // then we determine if the winding count increases or decreases based on the sign of the
    // triangle's area.

    if (point.y >= currentY) {
      if (point.y < nextY) {
        // If the sign of the triangle formed by the vector of the current two points
        // and the mouse point we are testing is negative, then the curve formed by
        // the two points passes the mouse point once counterclockwise,
        // so increase the number
        if (triangleAreaWithDirection < 0) {
          windingNumberCount += 1;
        }
      }
    } else if (point.y >= nextY) {
      // Similarly to above, if the sign of the area is negative then the curve formed by
      // the two points passes the mouse point once clockwise, so decrease the number
      if (triangleAreaWithDirection > 0) {
        windingNumberCount -= 1;
      }
    }
  } // As long as the winding count is not zero, then we know we have made at least one full
  // rotation around the point which means the point is inside the polygon


  return windingNumberCount !== 0;
}
/**
 * Takes a pair of screen coordinates and converts it to latitude and longitude on the map
 * @param screenX
 * @param screenY
 * @param gmap
 * @returns {*}
 */


function convertScreenXYToLatLng(screenX, screenY, gmap) {
  // eslint-disable-next-line no-restricted-properties
  var zoomScale = Math.pow(2, gmap.getZoom());
  var mapProjection = gmap.getProjection();
  var topRight = mapProjection.fromLatLngToPoint(gmap.getBounds().getNorthEast());
  var bottomLeft = mapProjection.fromLatLngToPoint(gmap.getBounds().getSouthWest());

  try {
    var worldPoint = new google.maps.Point(screenX / zoomScale + bottomLeft.x, screenY / zoomScale + topRight.y);
    return mapProjection.fromPointToLatLng(worldPoint);
  } catch (e) {
    return null;
  }
}
/**
 * Takes a pair of screen coordinates and converts it to latitude and longitude on the map
 * @param lat
 * @param lng
 * @param gmap
 * @returns {*}
 */


function convertLatLngToScreenXY(lat, lng, gmap) {
  // eslint-disable-next-line no-restricted-properties
  var zoomScale = Math.pow(2, gmap.getZoom());
  var mapProjection = gmap.getProjection();
  var topRight = mapProjection.fromLatLngToPoint(gmap.getBounds().getNorthEast());
  var bottomLeft = mapProjection.fromLatLngToPoint(gmap.getBounds().getSouthWest());

  try {
    var latLng = new google.maps.LatLng(lat, lng);
    var worldPoint = mapProjection.fromLatLngToPoint(latLng);
    var screenX = (worldPoint.x - bottomLeft.x) * zoomScale;
    var screenY = (worldPoint.y - topRight.y) * zoomScale;
    return {
      screenX: screenX,
      screenY: screenY
    };
  } catch (e) {
    console.error(e);
    return {};
  }
}
/**
 * Given a tile and zoom, determines the screen pixel location of the top left of the tile relative
 * to the origin (top left corner) of the google maps instance.
 * @param row
 * @param column
 * @param zoom
 * @param gmap
 * @returns {{x: number, y: number}}
 */


function getTileTopLeftScreenPixelCoordinates(row, column, gmap) {
  // eslint-disable-next-line no-restricted-properties
  var zoomScale = Math.pow(2, gmap.getZoom());
  var mapProjection = gmap.getProjection();
  var bounds = gmap.getBounds();

  var _tileToLatLng = tileToLatLng(row, column, gmap.getZoom()),
      latDeg = _tileToLatLng.latDeg,
      lngDeg = _tileToLatLng.lngDeg;

  var mapTopRightMercator = mapProjection.fromLatLngToPoint(bounds.getNorthEast());
  var mapBottomLeftMercator = mapProjection.fromLatLngToPoint(bounds.getSouthWest());

  try {
    var tileTopLeftMercator = mapProjection.fromLatLngToPoint(new google.maps.LatLng(latDeg, lngDeg));
    return {
      x: Math.floor((tileTopLeftMercator.x - mapBottomLeftMercator.x) * zoomScale),
      y: Math.floor((tileTopLeftMercator.y - mapTopRightMercator.y) * zoomScale)
    };
  } catch (e) {
    console.error(e);
    return {};
  }
}
/**
 * Given an object with the x and y value of the top left pixel coordinates of the screen relative
 * to the origin of the google map dive, translates the polygon array to start
 * at the top left corner of the tile.
 * @param tileTopLeftPixelCoords object{x: 100, y: 100}
 * @param polygon array of the shape [1, 1, 2, 2, 3, 3]
 *        which translates to the points (1,1), (2,2), (3,3)
 * @returns {*}
 */


var translatePolygonToMapTile = function translatePolygonToMapTile(tileTopLeftPixelCoords, polygon) {
  return polygon.map(function (point, index) {
    return point + (index % 2 === 0 ? tileTopLeftPixelCoords.x : tileTopLeftPixelCoords.y);
  });
};

exports.translatePolygonToMapTile = translatePolygonToMapTile;

function convertPolygonToLatLng(polygon, tileRow, tileCol, gmap) {
  if ((0, _isEmpty2.default)(polygon)) {
    return [];
  }

  var latLngPolygon = [];
  var tileTopLeft = getTileTopLeftScreenPixelCoordinates(tileRow, tileCol, gmap);
  var translatedToMapTile = translatePolygonToMapTile(tileTopLeft, polygon);

  for (var i = 0; i <= translatedToMapTile.length - 2; i += 2) {
    var screenX = translatedToMapTile[i];
    var screenY = translatedToMapTile[i + 1];
    var latLng = convertScreenXYToLatLng(screenX, screenY, gmap);

    if (latLng) {
      latLngPolygon[i] = latLng.lat();
      latLngPolygon[i + 1] = latLng.lng();
    }
  }

  return latLngPolygon;
}

function convertPolygonToScreenXY(polygon, gmap) {
  return polygon.reduce(function (accu, val, i, array) {
    var _convertLatLngToScree = convertLatLngToScreenXY(array[i], array[i + 1], gmap),
        screenX = _convertLatLngToScree.screenX,
        screenY = _convertLatLngToScree.screenY;

    return i % 2 ? accu : [].concat(_toConsumableArray(accu), [screenX, screenY]);
  }, []);
}
/**
 * Takes a parcel that is addressed to screen x y space and converts all of the polygons to
 * equivalent latitude and longitude coordinates.
 * @param parcel Parcel with the shape
 * {
 *      id: Number,
 *      mbr: [Numbers],
 *      polygons: [
 *          {
 *              holes: [
 *                  [Numbers],
 *              ],
 *              shell: [Numbers]
 *          }
 *      ]
 * }
 * @param tileRow The row of the tile the parcel is in
 * @param tileCol The column of the tile the parcel is in
 * @param gmap
 * @returns {{id: *, mbr, polygons: Array}}
 */


function convertParcelToLatLng(parcel, tileRow, tileCol, gmap) {
  var simplifiedConvert = function simplifiedConvert(polygon) {
    return convertPolygonToLatLng(polygon, tileRow, tileCol, gmap);
  };

  var id = parcel.id,
      mbr = parcel.mbr,
      polygons = parcel.polygons;
  return {
    id: id,
    mbr: simplifiedConvert(mbr),
    polygons: polygons.map(function (_ref) {
      var shell = _ref.shell,
          holes = _ref.holes;
      return {
        shell: simplifiedConvert(shell),
        holes: holes.map(simplifiedConvert)
      };
    })
  };
}

function translateScreenXYFromMapTile(tileTopLeftPixelCoords, screenX, screenY) {
  return {
    translatedX: screenX - tileTopLeftPixelCoords.x,
    translatedY: screenY - tileTopLeftPixelCoords.y
  };
}

function isScreenXYInsideMinimumBoundingRect(screenX, screenY, minimumBoundingRect) {
  var _minimumBoundingRect = _slicedToArray(minimumBoundingRect, 4),
      topLeftX = _minimumBoundingRect[0],
      topLeftY = _minimumBoundingRect[1],
      bottomRightX = _minimumBoundingRect[2],
      bottomRightY = _minimumBoundingRect[3];

  return screenX >= topLeftX && screenX <= bottomRightX && screenY >= topLeftY && screenY <= bottomRightY;
}
/**
 * Takes a pair of screen coordinates and converts it to a tile's row/column coordinates
 * relative to the google map's projection.
 * @param screenX
 * @param screenY
 * @param gmap
 * @returns {{row, column}}
 */


function getTileRowColFromScreenCoords(screenX, screenY, gmap) {
  var latLng = convertScreenXYToLatLng(screenX, screenY, gmap);

  if (latLng) {
    return latLngToTile(latLng.lat(), latLng.lng(), gmap.getZoom());
  }

  return {
    row: null,
    column: null
  };
}
/**
 * Accepts an array of x,y coordinate pairs and converts it to line for the path element to draw.
 * If we are at the first index of the array, we want to start drawing the line in a new place
 * on the screen, so we use the 'M' (move) command. Otherwise we use the 'L' (Line To) command
 * to continue drawing the line to the next pair of coordinates.
 *
 * @param coordinateArray array of x, y coordinates in the shape of [0,0,1,1,2,2] which translates
 * to (0,0), (1,1), (2,2) on a cartesian plane.
 * @returns {string} From the previous example, 'M 0 0 L 1 1 L 2 2'
 */


function getPathLineFromCoordinateArray(coordinateArray) {
  var length = coordinateArray.length;
  return length === 0 ? '' : coordinateArray.reduce(function (acc, coord, i) {
    return (// only insert L on non-terminal odd indices
      acc + " " + coord + (i !== length - 1 && i % 2 ? ' L' : '')
    );
  }, ' M');
}
/**
 * Returns props that are appropriate to forward to dom elements.
 * @param {} props 
 */


function getForwardableProperties(props) {
  /* eslint-disable react/prop-types */
  var forwardProps = {
    // Should not prop validate native element attributes
    className: props.className,
    style: props.style,
    role: props.role,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave
  };
  /* eslint-disable react/prop-types */

  return forwardProps;
}
/**
 * Returns a key consistning of the first and middle coordinate pair for the polygon.
 * We use the middle to avoid collision cases where two polygons start with the same
 * first coordinate.
 * @param {Array} polygon 
 */


function getCustomRegionPolygonKey(polygon) {
  if (!polygon) {
    return '';
  }

  var middle = Math.floor(polygon.length / 2);

  var _polygon = _slicedToArray(polygon, 2),
      firstCoord = _polygon[0],
      secondCoord = _polygon[1];

  var firstMiddleCoord = polygon[middle];
  var secondMiddleCoord = polygon[middle + 1];
  return firstCoord + "_" + secondCoord + "_" + firstMiddleCoord + "_" + secondMiddleCoord;
}